import FilterBuilder from "Services/Filters/FilterBuilder";
import {http} from "Services/Http/HttpClient";

export const getMonthlyFeeModifications = async (filters: any = {}): Promise<unknown> => {
    const queryParams = FilterBuilder.hashMapToQueryString(filters)
    return await http.get('month_fee_modifications' + (queryParams ? '?' + queryParams : ''))
}

export const getMonthlyFeeModificationDetail = async (id: string): Promise<unknown> => {
    return await http.get('month_fee_modifications/' + id)
}

export const exportMonthlyFeeModifications = async (
    filters: any = {}
) : Promise<unknown> => {
    const newFilters = {...filters, csv: "1"}
    return getMonthlyFeeModifications(newFilters);
}